export class ValidationsUtils {

  static required(key, values, errors) {
    if (!values[key]) {
      errors[key] = 'validations.required';
    }
  }

  static passwordRules(key, values, errors) {
    if (!values[key]) return;
    if (values[key].length < 8) {
      errors[key] = 'validations.passwordRules.length';
    } else if (!(/(?=.*?[a-z])/.test(values[key]))) {
      errors[key] = 'validations.passwordRules.lowercase';
    } else if (!(/(?=.*?[A-Z])/.test(values[key]))) {
      errors[key] = 'validations.passwordRules.uppercase';
    } else if (!(/(?=.*?[0-9])/.test(values[key]))) {
      errors[key] = 'validations.passwordRules.digit';
    } else if (!(/(?=.*?[#?!@$%^&*-])/.test(values[key]))) {
      errors[key] = 'validations.passwordRules.special';
    }
  }

  static verifyPassword(verifyElement, originalElement, values, errors) {
    if (values[verifyElement] !== values[originalElement]) {
      errors[verifyElement] = 'validations.verifyPassword';
    }
  }

  // @see http://emailregex.com/
  static validateEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  }

  static validatePhoneNumber(number) {
    return /^(\+\d{1,3}[- ]?)?\d{10}$/.test(number);
  }

  static validateEmailOrPhone(emailOrPhone) {
    return this.validateEmail(emailOrPhone)
      || this.validatePhoneNumber(emailOrPhone);
  }
}



// WEBPACK FOOTER //
// ./src/utils/validationUtils.js